import { lazy, Suspense } from 'react';
import { Flex, Spin } from 'antd';

// Home V2 (pages/HomeV2) is the Home for every environment. The pre-refactor
// Home (pages/Home) is kept in the repo as a fallback but is no longer routed
// here. Lazy on purpose -- both trees define the same .home-* class names with
// different rules, so the legacy stylesheet must not be loaded alongside V2.
const Home = lazy(() =>
  import('./HomeV2').then((module) => ({ default: module.Home }))
);

export default function HomeRoute() {
  return (
    <Suspense
      fallback={
        <Flex align='center' justify='center' style={{ minHeight: '60vh' }}>
          <Spin size='large' />
        </Flex>
      }
    >
      <Home />
    </Suspense>
  );
}
